import TimeMetrics from '../metrics/timeMetrics'

const MAX_RESPONSE_MESSAGE_COUNT = 10000
const CONTROL_MESSAGE_STATS_FLUSH_PERIOD = 5 * 60 * 1000

const controlMetrics = new TimeMetrics({
  analyticsEventName: 'Message Metrics',
  metricsType: 'control',
  periodicFlushInterval: CONTROL_MESSAGE_STATS_FLUSH_PERIOD,
  disableAnalytics: true, // 2025-07-30 Disable analytics reporting for message metrics
})

const responseMetrics = new TimeMetrics({
  analyticsEventName: 'Message Metrics',
  metricsType: 'scan',
  maxSampleSize: MAX_RESPONSE_MESSAGE_COUNT,
  disableAnalytics: true, // 2025-07-30 Disable analytics reporting for message metrics
})

export async function onControlMessage(message) {
  // record control message time
  controlMetrics.recordTimeSince(message.controlled)

  if (message.scanning) {
    // set responseMetrics to accept data
    responseMetrics.ensureOpened()
  } else {
    // end data session - stop accepting data
    responseMetrics.ensureClosed()
    // send metrics
    responseMetrics.flush()
  }
}

export async function onResponseMessage(message) {
  const messageContent = message.poll || message.setPollPoll
  responseMetrics.recordTimeSince(messageContent.maxCaptured)
}
